import axios from "axios";

export function buildApiBaseUrl(backendUrl) {
    const normalizedUrl = backendUrl?.trim().replace(/\/+$/, "");

    if (!normalizedUrl) return "/api";
    if (/\/api$/i.test(normalizedUrl)) return normalizedUrl;

    return `${normalizedUrl}/api`;
}

export const API_BASE = buildApiBaseUrl(process.env.REACT_APP_BACKEND_URL);

export function resolveApiResourceUrl(url) {
    if (!url || !url.startsWith("/api/")) return url;
    if (API_BASE === "/api") return url;
    return `${API_BASE.replace(/\/api$/i, "")}${url}`;
}

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export default api;

export function formatApiError(err) {
    if (err?.response?.status === 413) return "La photo est trop volumineuse. Taille maximale : 10 Mo.";
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Erreur inconnue";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" • ");
    if (d?.msg) return d.msg;
    return String(d);
}
